import request from '@/utils/request'

function getList(data) {
  return request({
    url: '/api/v1/admin/members/member_list/overview_1_1',
    method: 'post',
    mock: false,
    data,
  })
}

// /api/v1/admin/game/player/gold
function getPlayerGold(uid) {
  return request({
    url: '/api/v1/admin/game/player/gold',
    method: 'post',
    mock: false,
    data: {
      uid,
    },
  })
}
// /api/v1/admin/game/player/rtp
function getPlayerRtp(uid) {
  return request({
    url: '/api/v1/admin/game/player/rtp',
    method: 'post',
    mock: false,
    data: {
      uid,
    },
  })
}

function getBaseInfoV2(uid) {
  return request({
    url: '/api/v1/admin/members/member_list/base_info_1_1',
    method: 'post',
    mock: false,
    data: {
      uid,
    },
  })
}

function getDataOverview(data) {
  return request({
    url: '/api/v1/admin/members/member_list/data_overview',
    method: 'post',
    mock: false,
    data,
  })
}

function getBetLogList(data) {
  return request({
    url: '/api/v1/admin/members/member_list/bet_logs',
    method: 'post',
    mock: false,
    data,
  })
}

function getGoldChangeLogList(data) {
  return request({
    url: '/api/v1/admin/members/member_list/gold_change_logs',
    method: 'post',
    mock: false,
    data,
  })
}

function getPayinLogList(data) {
  return request({
    url: '/api/v1/admin/members/member_list/payin_logs',
    method: 'post',
    mock: false,
    data,
  })
}

function getPayoutLogList(data) {
  return request({
    url: '/api/v1/admin/members/member_list/payout_logs',
    method: 'post',
    mock: false,
    data,
  })
}

function getMemberLogList(data) {
  return request({
    url: '/api/v1/admin/members/member_logs/list',
    method: 'post',
    mock: false,
    data,
  })
}

function modifyLoginPassword(data) {
  return request({
    url: '/api/v1/admin/members/member_list/modify/save_player_password',
    method: 'post',
    mock: false,
    data,
  })
}

function resetPayPassword(data) {
  return request({
    url: '/api/v1/admin/members/member_list/modify/reset_payout_password',
    method: 'post',
    mock: false,
    data,
  })
}
// /api/v1/admin/game/player/set_rtp
function setRtp(data) {
  return request({
    url: '/api/v1/admin/game/player/set_rtp',
    method: 'post',
    mock: false,
    data,
  })
}

function getPayinChannelList() {
  return request({
    url: '/api/v1/admin/members/member_list/payin_channel',
    method: 'post',
    mock: false,
  })
}

export const MemberApi = {
  getPlayerGold,
  getPlayerRtp,
  getList,
  getBaseInfoV2,
  getDataOverview,
  getBetLogList,
  getGoldChangeLogList,
  getPayinLogList,
  getPayoutLogList,
  getMemberLogList,
  modifyLoginPassword,
  resetPayPassword,
  setRtp,
  getPayinChannelList,
}
